import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TrustPipe } from '@frontend/sports/common/core/utils/dom';

import { NumpadModule } from '../../../lib/numpad/numpad.module';
//import { EffectsModule } from '@ngrx/effects';
import BetslipBaseModule from '../../base/betslip-base.module';
import { StakeProgressBarComponent } from './components/stake-progress-bar.component';
import { UserStakeLimitsInfoComponent } from './components/user-stake-limit-info.component';
import { UserStakeLimitsComponent } from './components/user-stake-limits.component';
import { UserStakeLimitsService } from './services/user-stake-limits.service';

@NgModule({
    imports: [CommonModule, BetslipBaseModule, NumpadModule, TrustPipe /* EffectsModule.forFeature([StakeLimitEffects])*/],
    declarations: [StakeProgressBarComponent, UserStakeLimitsComponent, UserStakeLimitsInfoComponent],
    exports: [UserStakeLimitsComponent],
    providers: [UserStakeLimitsService],
})
export default class BetslipDigitalStakeLimitModule {}
